export default "__VITE_ASSET__2c00c6fe__"